import { matches } from '../matches/matches.js';

function isEmail(error) {
  return matches(/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,63})+$/, error);
}

export { isEmail };
//# sourceMappingURL=is-email.js.map
